import { ProfiBazaAPIModels } from '@services/src/profiBazaAPI';
import _ from 'lodash';

export const uniqueeNotifications = (
	data: ProfiBazaAPIModels.UserNotificationDTO[]
) => {
	return _.uniqBy(data, (value) => value.id);
};
